import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { CarrierStatusService } from './carrier-status.service';
import { SelectableLab } from '../carrier/selectable-lab';
import { MessagesService } from '../messages/messages.service';
import { ContainerStatus } from './carrier-status';
import { ErrorHandler } from '../utils/error-handler';
import { Machine } from '../masterdata/models/machine';
import { CarrierState } from '../masterdata/models/carrierState';
import { ProcessStep } from '../masterdata/models/processStep-enum';
import { Printer } from '../masterdata/models/printer';
import { ProcessState } from '../masterdata/models/processState-enum';
import { LabProcessingRequest } from './processing-request';

/**
   * @constructor
   * @param formBuilder
   * @param carrierStatusService
   * @param _messagesService
   * @param globals
   */
@Component({
  selector: 'app-carrier-status',
  templateUrl: './carrier-status.component.html',
  styleUrls: ['./carrier-status.component.css'],
})
export class CarrierStatusComponent implements OnInit {

  carrierStatusForm: FormGroup;

  submitted: boolean;

  createdBy: string;
  carrierBarcode: string;
  selectedLab: SelectableLab;
  carrierStatus:ContainerStatus[];
  carrierStatusCols:any[];
  errorHandler: ErrorHandler = new ErrorHandler;
  machineList:Machine[];
  selectedMachine:Machine;
  statusList:CarrierState[];
  selectedStatus:CarrierState;
  newCarrierBarcode:string;
  lableForCarrierBarcode:string;
  newCarrierCount:number = 0;
  machineBarcode:string;
  isMachineBarcodeValid:boolean;
  isReadyForSubmit:boolean;

  isMachine: string = "machine";
  isCreatedBy: string = "createdBy";
  isCreationDate : string = "creationDate";
  isCarrierState: string = "carrierState";
  isProcessState: string = "processState";
  isContainerBarcode: string ="containerBarcode";

  progressData:any;
  options:any;

  processStep: string;
  carrierStateDetails:CarrierState;

  printersList : Printer[];

  constructor(private formBuilder: FormBuilder, private carrierStatusService: CarrierStatusService,
     private _messagesService: MessagesService, ) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
    console.log("Lab in carrierStatus page :"+this.selectedLab);
  }

  ngOnInit() {

    this.carrierStatusService.getMachineList().subscribe(
      results => {
          this.machineList = results.data
    })

    this.carrierStatusService.getCarrierStateList().subscribe(
      results => {
        this.statusList = results.data
    })
    this.carrierStatusCols=[
      {field: 'creationDate' , header : 'Date' },
      {field: 'createdBy' , header : 'PUID' },
      {field: 'machine' , header : 'Machine Name' },
      {field: 'carrierState' , header : 'Status' },
      {field: 'containerBarcode' , header : 'Container Change' },
      {field: 'processState' , header : 'Event' }
    ];

    this.carrierStatusForm = this.formBuilder.group({
      'createdBy': new FormControl('', Validators.required),
      'carrierBarcode': new FormControl('', Validators.required),
      'machineBarcode': new FormControl('', Validators.required),
      'selectedStatus': new FormControl('', Validators.required),
      'newCarrierBarcode': new FormControl('', )
    });
  }

  //On tab change event
  onTabChange(event){
    console.log("Process step index : "+event.index);
    switch (event.index) {
      case 2: {
        this.processStep = ProcessStep.MERGING;
        this.getProcessStepDetail(this.processStep);
        break;
      }
      case 3: {
        this.processStep = ProcessStep.REACTION_MIX;
        this.getProcessStepDetail(this.processStep);
        break;
      }
      case 4: {
        this.processStep = ProcessStep.THERMAL_CYCLER;
        this.getProcessStepDetail(this.processStep);
        break;
      }
      case 5: {
        this.processStep = ProcessStep.DT_REMOVAL;
        this.getProcessStepDetail(this.processStep);
        break;
      }
      case 6: {
        this.processStep = ProcessStep.SPLITTING;
        this.getProcessStepDetail(this.processStep);
        break;
      }
      case 7: {
        this.processStep = ProcessStep.SEQUENCING;
        this.getProcessStepDetail(this.processStep);
        break;
      }
      case 8: {
        this.processStep = ProcessStep.PREPARING;
        this.getProcessStepDetail(this.processStep);
        break;
      }
      case 9: {
        this.processStep = ProcessStep.REDO;
        break;
      }
    }
  }


  //Get Process Step definition on tab change for selected Step
  getProcessStepDetail(step: string){

    this.getListOfPrinters();
    this.carrierStateDetails = null;

    this.carrierStatusService.getProcessStepDetails(step, this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("CS -> "+step+ "-> ", results.data);
        this.carrierStateDetails = results.data;
        if(!this.carrierStateDetails){
          this._messagesService.addErrorMessage({ severity: 'error', summary: results.bbApiError.title, detail: results.bbApiError.message });
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  //Get list of active printers for selected lab
  getListOfPrinters(){
    this.carrierStatusService.getPrintersList(this.selectedLab.lab, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Printers List -> ", results.data);
        this.printersList = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  /**
   * @function
   * @description: This method is to fetch carrier status details for entered carrier barcode
   */
  searchCarrier() {
    if (this.carrierBarcode) {
      this.carrierBarcode = this.carrierBarcode.trim();
      this.lableForCarrierBarcode = this.carrierBarcode

      this.carrierStatusService.searchByCarrierStatusByBarcode(this.carrierBarcode, this.selectedLab.lab).subscribe(
        results => {
          console.log(results);

          let carrierStatusList:ContainerStatus[] = results.data;
          for (let containerStatus of carrierStatusList) {
              if(containerStatus.newContainerBarcode){
                containerStatus.newContainerBarcode = containerStatus.newContainerBarcode.trim();
                containerStatus.containerBarcode = containerStatus.containerBarcode+" -> "+containerStatus.newContainerBarcode;
              }
          }
          this.carrierStatus = carrierStatusList;
        },
        error => {
          console.log(error);
          this._messagesService.addErrorMessage(this.errorHandler.handleError(error));
        }
      );
    }

  }
  /**
   * @function
   * @description: This method is to get the focus to Carrier Barcode Field
   */
  focusCarrierbarcode() {
    document.getElementById('carrierbarcode').focus();
  }
  /**
   * @function
   * @description: This method is to get the focus to Machine Barcode Field
   */
  focusMachinebarcode() {
    document.getElementById('machinebarcode').focus();
  }
 /**
   * @function
   * @description: This method is to get the focus to New Carrier Barcode Field
   */
  focusNewCarrierbarcode() {
    document.getElementById('newcarrierbarcode').focus();
  }
  /**
   * @function
   * @description: This method is to TBD
   */
  disableDefaultSubmit(event){
    event.preventDefault();
    event.target.blur();
  }
  /**
   * @function
   * @description: This method is to add Carrier status Details
   */
  addCarrierStatus(processState: ProcessState) {
    this.validateMachine();
    /** Validate New Carrier that it should not be used before */
    if(this.newCarrierCount > 0){
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Duplicate New Carrier', detail: "Carrier "+this.newCarrierBarcode+" is already used" });
      this.isReadyForSubmit = false;
      this.newCarrierCount = 0;
    }
    /** Validate Machine Barcode with Master Data  */
    else if(!this.isMachineBarcodeValid){
      this.isReadyForSubmit = false;
    }
    else{
      let status = new LabProcessingRequest;
      status.createdBy = this.createdBy;
      status.containerBarcode = this.carrierBarcode.trim();
      status.machine = this.selectedMachine;
      status.processState = processState;
      status.lab = this.selectedLab.lab;
      status.carrierState = this.selectedStatus;
      status.newContainerBarcode = this.newCarrierBarcode;

      this.carrierStatusService.addCarrierStatus(status).subscribe(
        results => {
          let containerStatus = results.data;
          if(containerStatus.newContainerBarcode){
            containerStatus.newContainerBarcode = containerStatus.newContainerBarcode.trim();
            containerStatus.containerBarcode = containerStatus.containerBarcode+" -> "+containerStatus.newContainerBarcode;
          }
          else{
            containerStatus.containerBarcode = ''
          }
          this.carrierStatus.push(containerStatus);
        },
        error => {
          if (error != null && error.error != null && error.error.bbApiError != null && error.error.bbApiError.errors != null) {
            this._messagesService.addErrorMessage({ severity: 'error', summary: error.error.bbApiError.title, detail:this.getSubErrors(error.error.bbApiError.errors) });
          }else{
            this._messagesService.addErrorMessage(this.errorHandler.handleError(error));
          }
        }
      );
      this.isReadyForSubmit = true;
    }
  }

  // used to get all the sub errors in the single string
  getSubErrors(errors:any[]){
    var errorText : string =''
    for(var e = 0; e < errors.length; e++){
      errorText += errors[e].message;
      if(e != errors.length - 1){
        errorText += (",");
      }
    }
    return errorText;
  }

   /**
   * @function
   * @description: This method is to get the count of new Carrier Barcode entered
   */
  validateNewCarrier(){
    this.carrierStatusService.getCountByCarrierBarcode(this.newCarrierBarcode, this.selectedLab.lab).subscribe(
      results => {
        if (results.data > 0) {
            this.newCarrierCount = results.data;
        }
      });
  }
  /**
   * @function
   * @description: This method is to validate Machine Barcode with Master Data
   */
  validateMachine(){
    this.isMachineBarcodeValid = false;
    this.selectedMachine = null
    //If Machine Barcode is not entered, don't validate
    if(!this.machineBarcode){
      return;
    }
    else{
        /* Check entered Machine is exist in Master list */
        for (let machine of this.machineList) {
            if(this.machineBarcode.trim() == machine.barcode){
                this.isMachineBarcodeValid = true;
                this.selectedMachine = machine;
            }
        }
        /* if not exist, show the error message*/
        if(!this.isMachineBarcodeValid){
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Machine Barcode', detail: "Please enter valid Machine Barcode" });
        }
      }
  }
  /**
   * @function
   * @description: This method is to add entry at start of the process of the Carrier State
   */
  start() {
    this.addCarrierStatus(ProcessState.STARTED)
    }
  /**
   * @function
   * @description: This method is to add entry at complete of the process of the Carrier State
   */
  complete() {
    this.addCarrierStatus(ProcessState.COMPLETED)
      }
  /**
   * @function
   * @description: This method is to TBD
   */
  onSubmit(value: string) {
    if(this.isReadyForSubmit){
      this.submitted = true;
      this.carrierStatusForm.reset();
      document.getElementById('createdby').focus();
    }
  }
  /**
   * @function
   * @description: This method is to TBD
   */
  epoch_to_hh_mm_ss(epoch: number) {
    return new Date(epoch * 1000).toISOString().substring(11, 5)
  }
}
